import { render, staticRenderFns } from "./DoctorDocumentsPage.vue?vue&type=template&id=2e63bc66&scoped=true"
import script from "./DoctorDocumentsPage.vue?vue&type=script&lang=js"
export * from "./DoctorDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./DoctorDocumentsPage.vue?vue&type=style&index=0&id=2e63bc66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e63bc66",
  null
  
)

export default component.exports